import type { ICreatePasswordLocale } from '../../../../../Pages/Onboard/CreatePassword/Locale/CreatePassword.locale';

const enUS: ICreatePasswordLocale = {
  title: 'Create your {brand} password',
  subtitle: 'Your password must meet the security requirements below.',
  password: {
    label: 'New Password',
    placeholder: 'Enter your new password',
    error: 'Password must meet all requirements',
  },
  confirmPassword: {
    label: 'Confirm Password',
    placeholder: 'Confirm your new password',
    error: 'Please confirm your password',
    mismatchError: 'Passwords do not match',
  },
  button: {
    createPassword: 'Create Password',
    creatingPassword: 'Creating Password...',
    backToLogin: 'Back to Login',
  },
  success: {
    title: 'Password created successfully!',
    message: 'Your password has been created. You can now log in to your account.',
  },
  requirements: {
    title: 'Password Requirements:',
    minLength: 'At least 8 characters',
    uppercase: 'One uppercase letter',
    lowercase: 'One lowercase letter',
    number: 'One number',
    specialChar: 'One special character',
  },
};

export { enUS };
